import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges } from '@angular/core';
import { User } from '../../models/user';
import { ChatService } from '../../../core/services/chat.service';
import { PersonaService } from '../../../core/services/persona.service';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss'],
  standalone: false,
})
export class ChatBoxComponent implements OnInit, OnChanges {
  @ViewChild('scroller', { static: true }) private feedContainer: ElementRef;
  @ViewChild('cardview') card: ElementRef;
  @Input() groupName: string;
  @Input() height = '300px';
  ulheight = '';
  public message: string = '';
  messageArray: Array<{ user: User; message: string; timesent: string }> = [];
  user: User;
  isTyping: boolean;
  userLoggedIn;
  constructor(
    private chatService: ChatService,
    private personaService: PersonaService,
  ) {
    // this.chatService.connectionSocket();
    // this.chatService.newMessageReceived().subscribe(data => {
    //   this.messageArray.push(data);
    //   this.isTyping = false;
    // });
  }
  ngOnChanges() {
    this.ulheight = '410px'; //(Number(this.height.substr(0, this.height.length - 2)) - 117) + 'px';
  }
  ngOnInit() {
    this.ulheight = '410px'; //(Number(this.height.substr(0, this.height.length - 2)) - 117) + 'px';
    //   this.userLoggedIn = JSON.parse(localStorage.getItem("loggedInUser"))
    //   // console.log(this.userLoggedIn)
    //   this.personaService.getLoggedUserDetails().subscribe(user => {
    //     console.log(user)
    //     this.user = user;
    //     this.chatService.joinRoom({user: this.user, room: this.groupName});
    //     // this.chatService.getChatRoomsChat(this.groupName).subscribe(messages => {
    //     //   this.messageArray = messages;
    //     //   // console.log(messages)
    //     // });
    //   })
  }
  sendMessage() {
    //   if (this.message.trim() === '' || this.user === null) {
    //     return 0;
    //   }
    //   let regExp = /^[a-zA-Z0-9_-\s]+$/
    //   if(regExp.test(this.message.trim())) {
    //     this.chatService.sendMessage({room: this.groupName, user: this.user, message: this.message.trim()});
    //     this.message = '';
    //   }
  }
  handleSubmit(_event) {
    //   // console.log(event.keyCode)
    //   if (event.keyCode === 13) {
    //     this.sendMessage();
    //   }
  }
  // ngAfterViewInit() {
  //   // let tmp = this.card.nativeElement.offsetHeight;
  //   // this.ulheight = (tmp - 116) + 'px';
  // }
  // scrollToBottom(): void {
  //   if (this.ulheight !== ''){
  //     this.feedContainer.nativeElement.scrollTop
  //     = this.feedContainer.nativeElement.scrollHeight;
  //   }
  // }
}
